import { Component, OnInit } from "@angular/core";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { RegistrationService } from "../../services/registration/registration.service";
import { MzToastService } from "ng2-materialize";

@Component({
  selector: "app-resend-activationlink",
  templateUrl: "./resend-activationlink.component.html",
  styleUrls: ["./resend-activationlink.component.scss"],
})
export class ResendActivationlinkComponent implements OnInit {
  env: any = environment;
  email: string;
  loading: boolean;
  error: string;
  linkExpiredError =
    "Dein Aktivierungslink ist abgelaufen. Bitte lass Dir einen neuen Link zuschicken.";
  userNotActivatedError =
    "Dein Account ist noch nicht aktiviert. Solltest Du Deinen Aktivierungslink nicht mehr haben, kannst Du Dir einen neuen zuschicken lassen.";
  invalidEmailError = {
    pattern: "Das E-Mail-Format ist ungültig.",
  };
  return = "" as string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private registrationService: RegistrationService,
    private toastService: MzToastService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.return = params["return"] || "/projects";
      this.email = params["email"];
      const status = params["status"];
      this.error = this.getError(status);
      console.log(this.error);
    });
    setTimeout(() => {
      $("#email").focus();
      $("#email").select();
    }, 100);
  }

  getError(status) {
    if (status === "0") return this.userNotActivatedError;
    else if (status === "1") return this.linkExpiredError;
  }

  isValidEmail(email) {
    if (!email) {
      return false;
    } else if (!/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/.exec(email)) {
      return false;
    }
    return true;
  }

  sendActivationLink() {
    this.loading = true;
    this.registrationService
      .resendLink(this.email)
      .then(() => {
        this.loading = false;
        this.router.navigate(["/login"], {
          queryParams: {
            email: this.email,
          },
        });
        this.toastService.show(
          " Eine E-Mail zum Aktivieren des Accounts wurde an: " +
            this.email +
            " verschickt.",
          4000,
          "confirm-toast"
        );
      })
      .catch((error) => {
        this.loading = false;
        this.error = "Ein Fehler ist aufgetreten.";
        //this.error = error.error.message;
      });
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/resend-activationlink/resend-activationlink.component.ts